import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CKEditorModule } from 'ng2-ckeditor';

import { HtmlEditorComponent } from './html-editor.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule, 
    CKEditorModule
  ],
  declarations: [HtmlEditorComponent],
  exports: [HtmlEditorComponent]
})
export class HtmlEditorModule { }
